// This file extends the jquery dialog to add common functionality to all dialogs
(function($) {
	$.extend($.ui.dialog.prototype.options, {
		open: function() {
			//TODO: find any instances in our code where we implement an enter key
			//listener to click a button on a dialog and remove these clicks. We can
			//then move this code from this open function (where it's usally overwritten)
			//to the dialogopen event below. Currently, it causes bugs due to double clicks
			
			// The first button in the dialog buttonbar will be clicked if the user
			// clicks the enter key
			var $this = $(this);
			
			var defbtn = $this.parent().find('.ui-dialog-buttonpane button').first();
			
			if (defbtn) {
				$this.keypress(function(e) {
				
					if (e.keyCode == 13) {
						e.preventDefault();
						defbtn.click();
					}
				});
			}
		},
		create: function() {
			var $this = $(this);
			
			$this.one('dialogopen', function () {
				
				var $visibleDialogArray = $('.ui-dialog:visible');
				var $visibleDialogOverlayArray = $('.ui-dialog:visible + .ui-widget-overlay');
				
				//If another dialog is visible, hide both it and its overlay
				if($visibleDialogArray.length > 1) {
					$this.lastDialogDisplayed = $visibleDialogArray.eq(0);
					$this.lastDialogDisplayed.hide();
					$this.lastDialogDisplayedOverlay = $visibleDialogOverlayArray.eq(0);
					$this.lastDialogDisplayedOverlay.hide();
				}
				
			});
			
			$this.one('dialogclose', function () {
				if (!!$this.lastDialogDisplayed) {
					$this.lastDialogDisplayed.show();
					$this.lastDialogDisplayedOverlay.show();
				}
				
				//If the dialog is not set to autoOpen, we can't destroy it
				//because it likely won't be created again when it's re-opened
				if ($this.dialog('option', 'autoOpen')) {
					$this.dialog("destroy");
				}
			});
		}
	});
})(jQuery);
